module.exports = __webpack_public_path__ + "img/29.c2546680.svg";